module.exports = __webpack_public_path__ + "img/ic-discover-white.b395c325.svg";